<template>
  <div class="user-wrapper">
    <div class="content-box">
      <!--<a href="https://help.dierqudao.com/" target="_blank">-->
        <!--<span class="action">-->
          <!--<a-icon type="question-circle-o"></a-icon>-->
        <!--</span>-->
      <!--</a>-->
<!--      <notice-icon class="action"/>-->
      <notice-icon class="action"/>
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <!--<a-avatar class="avatar" size="small" :src="avatar()"/>-->
          <span>{{ nickname() }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">

            <a-sub-menu   key="0">
            <span slot="title">
            <a-icon type="shop"/>
              <span> 切换省市</span></span>
                <a-menu-item @click="changeBusiness(b)" :key="b.id" v-for="b in businessList()" :disabled="businessId==b.id">{{b.name}}</a-menu-item>
            </a-sub-menu>
<!--          <a-menu-item key="0">-->
<!--            <router-link :to="{ name: 'center' }">-->
<!--              <a-icon type="user"/>-->
<!--              <span>个人中心</span>-->
<!--            </router-link>-->
<!--          </a-menu-item>-->
            <!--<a-menu-item key="1">-->
                <!--<router-link :to="{ name: 'SiteSettingPassword' }">-->
                    <!--<a-icon type="lock"/>-->
                    <!--<span>修改密码</span>-->
                <!--</router-link>-->
            <!--</a-menu-item>-->
            <!--<a-menu-divider/>-->
          <a-menu-item key="2">
            <a href="javascript:;" @click="handleLogout">
              <a-icon type="logout"/>
              <span>退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue'
import NoticeIcon from '@/components/NoticeIcon'
import { mapActions, mapGetters } from 'vuex'
    import { ACCESS_TOKEN,BUSINESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'UserMenu',
  components: {
    NoticeIcon
  },data () {
        return {
            businessName:'',
            businessId:''
        }
    },
    created () {
        const business = Vue.ls.get(BUSINESS_TOKEN)
        this.businessName = business.name;
        this.businessId = business.id;
      console.log('businessList()')
//      console.log(businessList())
    },
  methods: {
    ...mapActions(['Logout']),
    ...mapGetters(['nickname', 'avatar','businessList']),
    changeBusiness(business){
      Vue.ls.set(BUSINESS_TOKEN, business, 7 * 24 * 60 * 60 * 1000);
      window.location.reload();
    },
    handleLogout () {
      const that = this

      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk () {
          return that.Logout({}).then(() => {
            window.location.reload()
          }).catch(err => {
            that.$message.error({
              title: '错误',
              description: err.message
            })
          })
        },
        onCancel () {
        }
      })
    }
  }
}
</script>
